import React from 'react';
import { CheckIcon, LockIcon, GlobeIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { packageItems, images } from '../data/offer';
const perks = ['One-Time Payment', 'Instant Digital Access', 'Lifetime Access to Purchased Materials', 'No Monthly Subscription'];
export function Offer() {
  return <section id="offer" className="w-full bg-white px-4 py-16 sm:py-24" data-id="element-250" data-mp="p0a2v58evi64">
      <div className="mx-auto max-w-3xl" data-id="element-251" data-mp="p24qirb2hodw">
        <SectionHeading eyebrow="Your Complete Perio Blueprint™ Package" title="Here’s Everything You’ll Receive Today" data-id="element-252" data-mp="13y2h7u2820iq" />

        <img src={images.mockup} alt="Complete Perio Blueprint™ package" className="mx-auto mt-8 w-full max-w-xl" loading="lazy" data-id="element-253" data-mp="ywd66ef01mun" />

        <ul className="mt-8 divide-y divide-ink/10 rounded-3xl bg-cream px-5 sm:px-8" data-id="element-254" data-mp="2fe0te6sp52o6">
          {packageItems.map(item => <li key={item.title} className="flex gap-3 py-5" data-id="element-255" data-mp="pkqq2g8zw5cx">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-256" data-mp="pml7vloyzhcs">
                <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-257" data-mp="zietduko2l6p" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-258" data-mp="13ki7kqyq03vo">
                <p className="font-extrabold leading-snug text-ink" data-id="element-259" data-mp="13j74ktd3n05m">{item.title}</p>
                <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-260" data-mp="6v0rdi242zfq">{item.description}</p>
                <p className="mt-1.5 text-sm font-bold text-gum" data-id="element-261" data-mp="btlubp8qzx7v">
                  Reference value: <s data-id="element-262" data-mp="fu5u70kphexp">{item.value}</s>
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 overflow-hidden rounded-3xl bg-brand-dark text-center ring-4 ring-gold" data-id="element-263" data-mp="klxit5kaxal7">
          <div className="bg-gold px-4 py-3 text-sm font-black uppercase tracking-widest text-brand-dark" data-id="element-264" data-mp="3k84887lde6ze">
            Special Launch Offer
          </div>
          <div className="px-5 py-8 sm:px-10" data-id="element-265" data-mp="vfh6ode273lz">
            <p className="text-lg font-bold text-white/80" data-id="element-266" data-mp="ve62wdkm5vuv">
              Total reference value: <s className="text-white/60" data-id="element-267" data-mp="qfurvzil1fb2">$268</s>
            </p>
            <p className="mt-2 text-white/80" data-id="element-268" data-mp="155adl139aujw">You don’t have to pay $268.</p>
            <p className="text-white/80" data-id="element-269" data-mp="157d3ll4esnom">
              You don’t have to pay <s data-id="element-270" data-mp="106z7n1g3146y">$97</s>.
            </p>
            <p className="mt-5 text-sm font-bold uppercase tracking-wider text-gold" data-id="element-271" data-mp="cgv40u2w94fy">
              Today, get the complete Perio Blueprint™ for just:
            </p>
            <p className="mt-2 font-serif text-7xl font-black leading-none text-white sm:text-8xl" data-id="element-272" data-mp="7jmj4lqd2mb0">
              $27<span className="ml-1 align-top font-sans text-2xl font-extrabold" data-id="element-273" data-mp="liw0hoqazmgk">USD</span>
            </p>

            <ul className="mx-auto mt-6 grid max-w-md gap-2 text-left sm:grid-cols-2" data-id="element-274" data-mp="hi2dcxkoqboq">
              {perks.map(p => <li key={p} className="flex gap-2 text-[15px] font-semibold text-white" data-id="element-275" data-mp="1sv4pngfr4f33">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-276" data-mp="20enh8b329gna" />
                  {p}
                </li>)}
            </ul>

            <div className="mx-auto mt-6 flex max-w-md items-center justify-center gap-2 rounded-xl bg-white/10 px-4 py-3 text-sm text-white" data-id="element-277" data-mp="25bnqsvz4d1j5">
              <GlobeIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-278" data-mp="1verdmcy9zr89" />
              <span data-id="element-279" data-mp="2j5ev9pxztv80">
                <strong data-id="element-280" data-mp="2j66iacdiykmo">Automatic currency conversion:</strong> your local currency is converted at checkout, where
                supported.
              </span>
            </div>

            <div className="mt-8" data-id="element-281" data-mp="29fveqqxr6dgb">
              <CTAButton label="Get the Perio Blueprint™ for $27" tone="dark" subline="Secure Checkout · Instant Digital Delivery · 7-Day Guarantee" data-id="element-282" data-mp="29espeng2wj2i" />
            </div>

            <Countdown tone="dark" data-id="element-283" data-mp="3226ey0hg6ccl" />

            <ScarcityBar data-id="element-284" data-mp="36uzjan907io5" />

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-semibold text-white/70" data-id="element-285" data-mp="36wamakumkme7">
              <span className="flex items-center gap-1.5" data-id="element-286" data-mp="1j41pnpv9vmbq">
                <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-287" data-mp="1e6ic6s6efdku" /> Secure checkout
              </span>
              <span className="flex items-center gap-1.5" data-id="element-288" data-mp="19901aw8tmoa7">
                <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-289" data-mp="149dq0scjzi41" /> Instant delivery
              </span>
              <span className="flex items-center gap-1.5" data-id="element-290" data-mp="21xfdzc4hcuid">
                <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-291" data-mp="21yyt2zeegzik" /> 7-day guarantee
              </span>
            </div>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center text-[15px] leading-relaxed text-muted" data-id="element-292" data-mp="1s6172ja78sf7">
          For less than the cost of many professional educational resources, you’ll receive a visual reference system
          designed to help you organize your periodontal knowledge and structure your initial case review.
        </p>
      </div>
    </section>;
}